import { render } from "./ClubInternalInfoPage.vue?vue&type=template&id=c9c5f98c"
const script = {}

import exportComponent from "/home/user/ade-home/chantiervocal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__